import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * Beautifies a US phone number when the field loses focus and caps the raw
 * length while typing. Formats 10-digit numbers as "(123) 456-7890" and
 * "1" + 10 digits as "+1 (123) 456-7890"; anything else is left untouched so
 * international numbers still pass. The output stays valid against the existing
 * phone pattern validator.
 */
@Directive({
  selector: '[appPhoneFormat]',
  standalone: true,
})
export class PhoneFormatDirective {
  constructor(private readonly ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: any): void {
    // Cap raw entry so users can't paste a wall of digits.
    if ((event.target.value || '').length > 20) {
      const capped = event.target.value.substring(0, 20);
      this.ngControl.control?.setValue(capped);
    }
  }

  @HostListener('blur')
  onBlur(): void {
    const raw = (this.ngControl.value ?? '').toString().trim();
    const digits = raw.replace(/\D/g, '');
    let formatted = raw;
    if (digits.length === 10) {
      formatted = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    } else if (digits.length === 11 && digits.startsWith('1')) {
      const d = digits.slice(1);
      formatted = `+1 (${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
    }
    if (formatted !== raw) {
      this.ngControl.control?.setValue(formatted);
    }
  }
}
